export type ModalSize = "SMALL" | "MEDIUM" | "LARGE";
export const ModalSize = {
    SMALL: "SMALL" as ModalSize,
    MEDIUM: "MEDIUM" as ModalSize,
    LARGE: "LARGE" as ModalSize,
};
